import { render, staticRenderFns } from "./ManagePosition.vue?vue&type=template&id=5b78f98b&scoped=true"
import script from "./ManagePosition.vue?vue&type=script&lang=js"
export * from "./ManagePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78f98b",
  null
  
)

export default component.exports